import type { IndexDescription } from "src/db";

export const hasFacetFields = (description: IndexDescription[]): boolean =>
    description.some((field) => field.facet === true);
